export default {
	// Inhalt des Modals
	model: {
		id: 0,
		address: '',
		address_type: 1,
		city_id: -1,
		customer_id: -1,
		street: '',
		number: '',
		zip: '',
		city: '',
		description: '',
		is_main: false
	},

	name: 'addresses',

	// Die Spalten der Tabelle
	cols: [
		{
			'name': 'Haupt',
			'json': 'is_main',
			'type' (aValue) {
				return aValue === true ? [''] : []
				//return []
			},
			'hint': 'Zeigt an ob die Adresse die Hauptadresse ist.',
			'css': { 'default': '', true: 'btn btn-success btn-sm fa fa-check fa' },
			'colCSS': 'text-center'
		},
		{ 'name': 'Art', 'json': 'mode_name', 'type': 'text'},
		{ 'name': 'Anschrift', 'json': 'address', 'type': 'text'},
		{ 'name': 'Bemerkung', 'json': 'description', 'type': 'text'}
	],

	relations: [
		'customers',
		'graves'
	],

	copy (aModel) {
		try {
			this.model.id = aModel.id
			this.model.kind_id = aModel.kind_id
			this.model.customer_id = aModel.customer_id
			this.model.street = aModel.street
			this.model.number = aModel.number
			this.model.zip = aModel.zip
			this.model.city = aModel.city
			this.model.address = aModel.address
			this.model.address_type = aModel.address_type
			this.model.mode_name = aModel.mode_name
			this.model.description = aModel.description
			this.model.is_main = aModel.is_main
		} catch (e) {
			return false
		}

		return true
	},

	clear () {
		this.model.id = 0
		this.model.kind_id = -1
		this.model.city_id = -1
		this.model.street = ''
		this.model.customer_id = -1
		this.model.number = ''
		this.model.zip = ''
		this.model.city = ''
		this.model.address = ''
		this.model.address_type = 1
		this.model.mode_name = ''
		this.model.description = ''
		this.model.is_main = false
	},

	validate () {
		const parts = this.model.zip.split(/\s/)
		if (parts.length !== 2) {
			return false
		}

		this.model.zip = parts[0]
		this.model.city = parts[1]

		this.model.address = this.model.firstname + ' ' + this.model.lastname + '\n'
		this.model.address += this.model.street + ' ' + this.model.number + '\n'
		this.model.address += this.model.zip + ' ' + this.model.city

		return true
	},

	validateModel () {
		return true
	}
}



// WEBPACK FOOTER //
// ./src/models/addresses.js